module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/transfer/transfer-authorization/transfer-authorization-grid/transfer-authorization-grid.component.css
// module id = ./src/app/hrms/transfer/transfer-authorization/transfer-authorization-grid/transfer-authorization-grid.component.css
// module chunks = main